import { DefaultValue } from 'recoil';
import {
	ReadWriteSetNewValue,
	ReadWriteSetNewValueNoDefault
} from '../../types/ReadWriteSet';

export const isNotDefaultValue = <T>(
	t: ReadWriteSetNewValue<T>
): t is ReadWriteSetNewValueNoDefault<T> => !(t instanceof DefaultValue);
